import useDetectBreakpoint from 'hooks/useDetectBreakpoint'
import clsx from 'clsx'
import Image from 'snippets/image/image'

function PlpBannerCard({ product, countFilterSelected }) {
  const { isDesktop } = useDetectBreakpoint()
  const media = isDesktop ? product.image : product.imageMobile
  const limitedDescription =
    product.description.length > 250 ? `${product.description.substring(0, 250)}...` : product.description

  if (countFilterSelected > 0) return null

  return (
    <div className="group relative col-span-2 flex flex-col overflow-hidden border-b border-neutral-900 lg:border-r">
      <div className="aspect-[376/301] w-full overflow-hidden md:aspect-[359/223]">
        {product.useVideo && product.videoUrl ? (
          <div
            className="relative h-full w-full"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: `
                <video-player
                  src="${product.videoUrl}"
                  data-thumbnail="${media}"
                  data-video-type="${product.videoType || 'mp4'}"
                  class="aspect-[376/301] md:aspect-[359/223]"
                  muted
                  playsinline
                  loop
                  autoplay
                  lazyload
                />
              `
            }}
          />
        ) : (
          <Image
            url={media}
            alt={product.heading}
            width={718}
            height={446}
            imageClass="w-full h-full"
            className="h-full w-full white-overlay white-overlay-group-hover"
          />
        )}
      </div>
      <div
        className={clsx(
          'flex flex-1 flex-col gap-8 bg-white px-5 py-6 md:px-4 lg:flex-row lg:items-center lg:justify-between',
          {
            'md-max:text-center': product.centerOnMobile
          }
        )}
      >
        <div>
          {product.heading && <div className="text-2xl font-extrabold uppercase text-neutral-900">{product.heading}</div>}
          {product.description && (
            <div className="mt-2 break-word text-xs text-neutral-700">{limitedDescription}</div>
          )}
        </div>
        {product.ctaLink && product.ctaText && (
          <a href={product.ctaLink} className="button-outlined w-full shrink-0 lg:w-fit lg:min-w-[125px]">
            {product.ctaText}
          </a>
        )}
      </div>
    </div>
  )
}

export default PlpBannerCard
